import { useAuthSiteStore } from '@/stores/AuthStore'
import axios from 'axios'
import { Notification } from './notifications'
import router from '@/router'

const request = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL_BACKEND,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
request.interceptors.request.use(
  function (config) {

    const authSiteStore = useAuthSiteStore()

    if (authSiteStore.token) {
      config.headers.set('Authorization', `Bearer ${authSiteStore.token}`)
    }

    // Faz alguma coisa antes da requisição ser enviada
    config.headers.set('owner-url', window.location.host)

    return config
  },
  function (error) {
    // Faz alguma coisa com o erro da requisição
    return Promise.reject(error)
  },
)

// Response interceptor
request.interceptors.response.use(
  function (response) {
    return response
  },
  async function (error) {
    const authSiteStore = useAuthSiteStore()

    if (error.response && error.response.status === 401) {
      const currentRoute = router.currentRoute.value
      const ambient = currentRoute.meta.ambient

      let destination = 'ecommerce-login'
      let params = {}

      if (ambient === 'afiliado-loja') {
        destination = 'affiliate-loja-login'
        if (currentRoute.params.code) {
          params = { code: currentRoute.params.code }
        }
      } else if (ambient === 'afiliado-portal') {
        destination = 'affiliate-portal-login'
      }

      authSiteStore.logout()

      // Evita disparar a notificação e o push se já estivermos na rota de login correta
      if (currentRoute.name !== destination) {
        Notification.info('Sua sessão expirou. Por favor, faça login novamente.')
        router.push({ name: destination, params })
      }

      return new Promise(() => {})
    }

    return Promise.reject(error)
  },
)

export default request
